module.exports = __webpack_public_path__ + "img/europe_icon_ue.0d6acea8.png";